import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsolGroupEditService {

  constructor(private http: HttpClient) { }

  /**
   * Get Tax Years
   * Action Code: i0gxca (Action id 32106)
   */
  getTaxYears(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=i0gxca`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get RAF Scenario
   * Action Code: lkh2g7 (Action id 32145)
   */
  getRAFScenario(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=lkh2g7`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Head LEID
   * Action Code: 0lvk86 (Action id 32107)
   */
  getHeadleid(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=0lvk86`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Currencies
   * Action Code: 3ucwjb (Action id 158)
   */
  getCurrencies(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=3ucwjb`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Tax Owners
   * Action Code: fzyjyg (Action id 32110)
   */
  getTaxOwners(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=fzyjyg`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Non Members List
   * Action Code: th6d65 (Action id 32117)
   */
  getNonMembersList(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=th6d65`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Members List
   * Action Code: x91mvh (Action id 32118)
   */
  getMembersList(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=x91mvh`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Country List
   * Action Code: a4wyxl (Action id 31651)
   */
  getCountryList(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=a4wyxl`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Members Consol Amounts
   * Action Code: gfb8hh (Action id 32124)
   */
  getMembersConsolAmts(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=gfb8hh`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Save/Update Consol Groups
   * Action Code: 01adx5 (Action id 32112)
   * Process: FTR_CONSOL_GROUP_SAVE_EDIT
   */
  saveUpdateGroups(
    baseUrl: string,
    data: any[],
    reqParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=01adx5`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify({});

    let params: any = { ...reqParams };
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FTR_CONSOL_GROUP_SAVE_EDIT';

    return this.makeSaveRequest(url, params, globalService);
  }

  /**
   * Save/Update Consol Members
   * Action Code: 0b0lfy (Action id 32122)
   * Process: FTR_CONSOL_MEMBERS_SAVE_EDIT
   */
  saveUpdateConsolMembers(
    baseUrl: string,
    data: any[],
    reqParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=0b0lfy`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify({});

    let params: any = { ...reqParams };
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FTR_CONSOL_MEMBERS_SAVE_EDIT';

    return this.makeSaveRequest(url, params, globalService);
  }

  /**
   * Save/Update Consol Group Amounts
   * Action Code: 9khqkb (Action id 32123)
   * Process: FTR_CONSOL_GROUP_AMTS_SAVE_EDIT
   */
  saveUpdateConsolGroupAmts(
    baseUrl: string,
    data: any[],
    reqParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=9khqkb`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify({});

    let params: any = { ...reqParams };
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FTR_CONSOL_GROUP_AMTS_SAVE_EDIT';

    return this.makeSaveRequest(url, params, globalService);
  }

  /**
   * Save/Update Tax Owners
   * Action Code: cbds5v (Action id 32392)
   * Process: FTR_CONSOL_GROUP_TAX_OWNER_SAVE_EDIT
   */
  saveUpdateTaxOwners(
    baseUrl: string,
    data: any[],
    reqParams: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=cbds5v`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify({});

    let params: any = { ...reqParams };
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FTR_CONSOL_GROUP_TAX_OWNER_SAVE_EDIT';

    return this.makeSaveRequest(url, params, globalService);
  }

  private makeRequest(url: string, params: any, globalService: any): Observable<any> {
    let requestParams: any = { ...params };
    if (globalService?.globalParams) {
      requestParams = { ...globalService.globalParams, ...requestParams };
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in request:', error);
        throw error;
      })
    );
  }

  private makeSaveRequest(url: string, params: any, globalService: any): Observable<any> {
    let requestParams: any = { ...params };
    if (globalService?.globalParams) {
      requestParams = { ...globalService.globalParams, ...requestParams };
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in save request:', error);
        throw error;
      })
    );
  }
}
